import { mockCustomerType } from './MockCustomerProducts';

export const mockCustomer = async () => {
	await new Promise((resolve) => setTimeout(resolve, 250));
	switch (mockCustomerType) {
		case -1:
			return mockUnknownCustomer_;
		default:
			return mockCustomer_;
	}
};

const mockCustomer_ = {
	customer_id: '1957175712',
	businessbrand: '339996a3-4df2-4230-bfe9-3051a98500cb',
	account_list: [
		{
			account_id: '1957175712',
			alt_account_id: '14190706',
			source_system: 'CodanTIA',
		},
	],
	tags: '#private #customer #insurance #CodanTIA',
	name: 'XDzfQMGhbeVWkHB9APwnz3Zs4W70I7MA@clients',
	person: {
		person_id: '1957175712',
		cpr_nr: '05106800445',
		firstname: 'Klaus Lokmann',
		lastname: 'Knudsen',
		roles: [],
	},
	contact: {
		address: {
			kvhx: '1012136029 02TH',
			street_number: '1',
			street_name: 'Bournonvillesvej',
			building_no_and_letter: '1A',
			postal_code: 3480,
			city_name: 'Fredensborg',
			// floor: '2',
		},
		contact_details: [
			{
				detail: '1',
				type: 'Street_Number__c',
			},
			// {
			// 	detail: 'TH',
			// 	type: 'Floor_Door__c',
			// },
			{
				detail: 'Fredensborg',
				type: 'City__c',
			},
			{
				detail: '0014I00002YDDnPQAX',
				type: 'Account_18_character_ID__c',
			},
			{
				detail: 'PRIVATE',
				type: 'Customer_Type__c',
			},
			{
				detail: 'Klaus Lokmann',
				type: 'FirstName',
			},
			// {
			// 	detail: '2',
			// 	type: 'Floor__c',
			// },
			{
				detail: '41414141',
				type: 'Mobile__c',
			},
			{
				detail: '3480',
				type: 'Postal_Code__c',
			},
			{
				detail: 'Knudsen',
				type: 'LastName',
			},
			{
				detail: 'Bournonvillesvej',
				type: 'Street__c',
			},
			{
				detail: 'k.lokmann@gmail.com',
				type: 'Email__c',
			},
			{
				detail: 'Klaus Lokmann Knudsen',
				type: 'Name',
			},
		],
	},
	consent: [],
};

const mockUnknownCustomer_ = {
	account_list: [],
	tags: '#unknown #NotABGroupCustomer',
	name: 'wa5ysDqvEa1IOp947zFGHsfv7dSjnBFr@clients',
	consent: [],
};
